import { __extends } from "tslib";
import ViewModelBase from "./ViewModelBase";
import { Misc, AppServices } from '@singularsystems/neo-core';
var EmptyViewModel = /** @class */ (function (_super) {
    __extends(EmptyViewModel, _super);
    function EmptyViewModel(taskRunner) {
        if (taskRunner === void 0) { taskRunner = Misc.Globals.appService.get(AppServices.NeoTypes.TaskRunner); }
        return _super.call(this, taskRunner) || this;
    }
    EmptyViewModel.prototype.initialise = function () {
    };
    return EmptyViewModel;
}(ViewModelBase));
export default EmptyViewModel;
